import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React from 'react';

import TextBoxControl from '../editor/controls/TextBox';

const useStyles = makeStyles({
  column: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 600,
    marginTop: 5,
    marginRight: 35,
  },
  firstColumn: {
    marginTop: 4,
  },
});

const DetailsRow = ({ isEditMode, leftLabel, rightLabel, leftFieldKey, rightFieldKey }) => {
  const classes = useStyles();

  return (
    <>
      <Grid item className={classes.firstColumn} xs={12} lg={5}>
        <div className={classes.column}>
          <TextBoxControl label={leftLabel} prop={leftFieldKey} disabled={!isEditMode} />
        </div>
      </Grid>
      <Grid item xs={12} lg={5}>
        <div className={classes.column}>
          {rightFieldKey && (
            <TextBoxControl label={rightLabel} prop={rightFieldKey} disabled={!isEditMode} />
          )}
        </div>
      </Grid>
    </>
  );
};

export default DetailsRow;
